import React, { useState, useEffect, useMemo } from 'react';
import { Flex, FormControl, FormLabel, Input, Select } from '@chakra-ui/react';
import { debounce } from 'throttle-debounce';
import { REASON_OPTIONS } from 'api/administrador/refunds';

const fieldStyles = {
  size: 'sm',
  bg: 'white',
  borderColor: 'gray.300',
  borderRadius: 'md',
  fontSize: 'sm',
  h: '36px',
  _hover: { borderColor: 'gray.400' },
  _focus: { borderColor: '#574feb', boxShadow: '0 0 0 1px #574feb' },
};

const labelStyles = {
  fontSize: '11px',
  fontWeight: 'semibold',
  color: 'gray.500',
  mb: 1,
  letterSpacing: 'wider',
  textTransform: 'uppercase',
};

export default function RefundFilters({ filters, onChange, programTypes }) {
  const [studentCodeInput, setStudentCodeInput] = useState(filters.studentCode);

  useEffect(() => {
    setStudentCodeInput(filters.studentCode);
  }, [filters.studentCode]);

  const debouncedStudentCodeChange = useMemo(
    () =>
      debounce(400, (value) => {
        onChange({ studentCode: value });
      }),
    [onChange]
  );

  useEffect(() => () => debouncedStudentCodeChange.cancel(), [debouncedStudentCodeChange]);

  const handleStudentCodeChange = (e) => {
    const value = e.target.value;
    setStudentCodeInput(value);
    debouncedStudentCodeChange(value);
  };

  return (
    <Flex
      px={5}
      py={4}
      gap={4}
      flexWrap="wrap"
      align="flex-end"
      borderBottom="1px solid"
      borderColor="gray.100"
    >
      <FormControl flex="1" minW="150px" maxW="200px">
        <FormLabel {...labelStyles}>Código estudiante</FormLabel>
        <Input
          {...fieldStyles}
          placeholder="Ej: 45821"
          value={studentCodeInput}
          onChange={handleStudentCodeChange}
        />
      </FormControl>

      <FormControl flex="1" minW="170px" maxW="250px">
        <FormLabel {...labelStyles}>Programa</FormLabel>
        <Select
          {...fieldStyles}
          value={filters.programTypeId}
          onChange={(e) => onChange({ programTypeId: e.target.value })}
        >
          <option value="">Todos los programas</option>
          {programTypes.map((pt) => (
            <option key={pt.id} value={pt.id}>
              {pt.name}
            </option>
          ))}
        </Select>
      </FormControl>

      <FormControl flex="1" minW="150px" maxW="220px">
        <FormLabel {...labelStyles}>Motivo</FormLabel>
        <Select
          {...fieldStyles}
          value={filters.reason}
          onChange={(e) => onChange({ reason: e.target.value })}
        >
          <option value="">Todos los motivos</option>
          {REASON_OPTIONS.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </Select>
      </FormControl>
    </Flex>
  );
}
